import { staffAttendance } from "../client";

export const addStaffNotification = (params) => {
  const user = {
    flag: "addStaffNotification",
    parameters: {
      addStaffNotification: params,
    },
  };
  return staffAttendance.post("/admin/staff/add/notification", user);
};

export const getAllStaffNotification = (params) => {
  const user = {
    flag: "getAllStaffNotification",
    parameters: params,
  };
  return staffAttendance.post("/admin/staff/getall/notification", user);
};

export const getStaffNotification = (params) => {
  const user = {
    flag: "getStaffNotification",
    parameters: params,
  };
  return staffAttendance.post("/admin/staff/get/notification", user);
};

export const deleteStaffNotification = (params) => {
  const user = {
    flag: "deleteStaffNotification",
    parameters: params,
  };
  return staffAttendance.delete("/admin/staff/delete/notification", {
    data: user,
  });
};

export const readStaffNotification = (params) => {
  const user = {
    flag: "readStaffNotification",
    parameters: params,
  };
  return staffAttendance.post("/admin/staff/read/notification", user);
};
